import {useIntl} from "react-intl";
import {Field} from "formik";
import { cities, tipoActividad, typeIdentification } from "../../../__mocks__/data";
import { useRequestContext } from "../../../hooks/useRequestContext";
import { renderTypeIdentificationDescription } from "../../../utils/utils";
import { useFormikContext } from 'formik';
import { useEffect, useState } from "react";
import { AdminService } from "../../../services";
import _ from "lodash";


interface FormCompanyInfoProps {
    errors?: any;
    values?: any;
    setPopup: React.Dispatch<React.SetStateAction<string>>;
}

export function FormCompanyInfo(props: FormCompanyInfoProps) {
    const {errors, values} = props;
    const intl = useIntl();
    
    const {request} = useRequestContext();
    const [allCiudades, setAllCiudades] = useState(cities as any);
 

    const { setFieldValue } = useFormikContext<any>(); // o el tipo adecuado

     const handleCiiuBlur = () => {
        const ciiuValue = values.Pws_Cod_ciu;
        console.log('CIIU Value:', ciiuValue);
        const actividad = tipoActividad.WS_TIPOS_ACT_ECONOMICA_IResult.listActEcon.Datos_ActividadEcon
            .find(item => item.s_codigo == ciiuValue);

         if (actividad) {
            setFieldValue('Pws_act_eco', actividad.s_codigo); // 👈 esto actualiza reactivamente
            console.log('Actividad económica encontrada:', actividad);
        } else {
            setFieldValue('Pws_act_eco', '');
            props.setPopup('CIIU_NOT_FOUND');
            console.log('No se encontró actividad económica');
        }
    };

     let citiesDepent2 = {
        "ListCiudad": {
            "Datos_Ciudad": [] as any
        }
    }
    useEffect(() => {
          AdminService.getAllCiudades().then((Datos:any)=>{
            console.log('Datos', Datos.payload.data.ListCiudad.Datos_Ciudad);
                    citiesDepent2.ListCiudad.Datos_Ciudad  = _.filter(Datos.payload.data.ListCiudad.Datos_Ciudad, { s_nivel: '3'});
                       setAllCiudades(citiesDepent2);
                     
          })
         
    }, []);

 

    return (
        <div className="row container-border-app">

            <div className="row">
                <div className="col-12 text-left">
                    <h3>Información de la empresa</h3>
                </div>
            </div>
            
            <div className="row">
                <div className="col">
                    <div className={"label-fields-peps-mobile display-flex"}>Nombre sociedad</div>
                    <p className="mb-0 form-company-info-text-value" style={{padding: '10px 0', wordBreak: 'break-word'}}>{values.Pws_Nom_socie || ''}</p>
                </div>
                
                <div className="col">
                    <div className={"label-fields-peps-mobile display-flex"}>Tipo Identificación</div>
                    <p className="mb-0 form-company-info-text-value" style={{padding: '10px 0'}}>{renderTypeIdentificationDescription(values.Pws_Tip_Identificacion!) || ''}</p>
                </div>
                
                <div className="col">
                    <div className={"label-fields-peps-mobile display-flex"}>Fecha Creación</div>
                    <div className="display-flex">
                        <Field name="Pws_Fec_cre" type="date"
                               className={`${errors.Pws_Fec_cre ? 'form-know-you-item-input-smaller display-flex input-error' : 'form-know-you-item-input-smaller display-flex'}`}/>
                    </div>
                </div>

                <div className="col">
                    <div className={"label-fields-peps-mobile display-flex"}>Código CIIU</div>
                    <div className="display-flex">
                        <Field name="Pws_Cod_ciu"
                            onBlur={handleCiiuBlur}
                            className={`${errors.Pws_Cod_ciu ? 'form-know-you-item-input-smaller display-flex input-error' : 'form-know-you-item-input-smaller display-flex'}`}/>
                    </div>
                </div>

            </div>
            
            <div className="row">
               
                <div className="col">
                    <div className={"label-fields-peps-mobile display-flex"}>Actividad económica</div>
                    <div className="display-flex">
                        {/* <Field name="Pws_act_eco"
                               className={`${errors.Pws_act_eco ? 'form-know-you-item-input-smaller display-flex input-error' : 'form-know-you-item-input-smaller display-flex'}`}/> */}
                               <Field as="select" name="Pws_act_eco"
                               className={`${errors.Pws_act_eco ? 'form-know-you-item-input-smaller display-flex input-error' : 'form-know-you-item-input-smaller display-flex'}`}>
                            <option value="">Seleccione...</option>
                            {
                                tipoActividad.WS_TIPOS_ACT_ECONOMICA_IResult.listActEcon.Datos_ActividadEcon.map((item) => (
                                    <option key={item.s_codigo} value={item.s_codigo}>{item.s_descripcion.slice(0, 20) + "..."}</option>
                                ))
                            }
                        </Field>
                    </div>
                     
                </div>
                
                <div className="col">
                    <div className={"label-fields-peps-mobile display-flex"}>Tipo de empresa</div>
                    <div className="display-flex">
                        <Field as="select" name="Pws_tip_emp"
                               className={`${errors.Pws_tip_emp ? 'form-know-you-item-input-smaller display-flex input-error' : 'form-know-you-item-input-smaller display-flex'}`}>
                            <option value="">Seleccione...</option>
                            <option value="PRIVADA">Privada</option>
                            <option value="MIXTA">Mixta</option>
                            <option value="PUBLICA">Pública</option>
                        </Field>
                    </div>
                </div>

                <div className="col">
                    <div className={"label-fields-peps-mobile display-flex"}>Dirección</div>
                    <div className="display-flex">
                        <Field name="Pws_Direccion"
                               className={`${errors.Pws_Direccion ? 'form-know-you-item-input-smaller display-flex input-error' : 'form-know-you-item-input-smaller display-flex'}`}
                               placeholder={intl.formatMessage({id: "Dirección"})}/>
                    </div>
                </div>
                
                {/* <div className="col">
                    <div className={"label-fields-peps-mobile display-flex"}>Ciudad</div>
                    <div className="display-flex">
                        <Field name="Pws_Ciudad"
                               className={`${errors.Pws_Ciudad ? 'form-know-you-item-input-smaller display-flex input-error' : 'form-know-you-item-input-smaller display-flex'}`}
                               placeholder={intl.formatMessage({id: "Ciudad"})}/>
                    </div>
                </div> */}

                <div className="col">
                    <div className="label-fields-peps-mobile display-flex">Ciudad</div>
                    <div className="display-flex">
                        <Field as="select" name="Pws_Ciudad"
                              className={`${errors.Pws_Ciudad ? 'form-know-you-item-input-smaller display-flex input-error' : 'form-know-you-item-input-smaller display-flex'}`}>

                            <option value="">Seleccione...</option>
                            {allCiudades?.ListCiudad?.Datos_Ciudad?.map((item:any, key: number) => (
                                <option key={key} value={item.s_codigo}>{item.s_nombre}</option>
                            ))}
                        </Field>
                    </div>
                    </div>

                   
                {/* <div className="col">
                    <div className={"label-fields-peps-mobile display-flex"}>Correo electrónico</div>
                    <div className="display-flex">
                        <Field name="Pws_Correo"
                               type="email"
                               className={`${errors.Pws_Correo ? 'form-know-you-item-input-smaller display-flex input-error' : 'form-know-you-item-input-smaller display-flex'}`}
                               placeholder={intl.formatMessage({id: "placeholder_mail"})}/>
                    </div>
                </div> */}
{/*                         
                <div className="col">
                    <div className={"label-fields-peps-mobile display-flex"}></div>
                    <div className="display-flex">
                      
                    </div>
                </div>

                <div className="col">
                    <div className={"label-fields-peps-mobile display-flex"}></div>
                    <div className="display-flex">
                      
                    </div>
                </div> */}


            </div>

            {/* Sección de Contacto - Campos editables */}
            {/* <div className="row">
                
             
            </div> */}

           
        </div>
    );
}